<template>
  <div class="details">
    <Instructor
      class="details__instructor"
      :instructor="course.instructors[0]"
      @search-instructor="searchPresenter"
    />
    <Stats
      class="details__stats"
      :courseDuration="courseDuration"
      :courseId="course.id"
      :difficulty="course.difficulty"
      :isAuthenticated="isAuthenticated"
      :files="files"
    />
  </div>
</template>

<script>
import Instructor from '@/components/course/details/Instructor.vue'
import Stats from '@/components/course/details/Stats.vue'

export default {
  name: 'Details',
  components: {
    Instructor,
    Stats,
  },
  props: {
    course: {
      type: Object,
      required: true,
    },
    files: {
      type: Array,
      required: true,
    },
    isAuthenticated: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    courseDuration() {
      const { duration_in_seconds: duration } = this.course
      return this.$duration.durationFromSecs(duration)
    },
  },
  methods: {
    searchPresenter(name) {
      this.$store.dispatch('search/setQuery', '')
      this.$router.push({
        name: 'search',
        query: { Instructors: name },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.details {
  position: relative;
  background-color: transparent;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  justify-content: center;
  &__instructor {
    flex: 50% 1 0;
  }
  &__stats {
    flex: 50% 1 0;
  }
}
</style>
